import React from "react";
import NotaCell from "@Features/ChatTagsReport/Components/NotaCell";

export const cerradasDetalladasColumns = [
	{ label: "Plataforma", key: "channel.platform.name", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Cuenta", key: "channel.label", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Grupos", key: "group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Usuario", key: "user.fullName", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Contacto", key: "contact.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Teléfono", key: "contact.phone", format: "phone", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Fecha Entrada", key: "createdDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Fecha Cierre", key: "closeDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
	{
		label: "Tiempo Total",
		key: "createdDate",
		endDateKey: "closeDate",
		format: "timeBetween",
		headerPosition: "center",
		dataPosition: "left",
		width: 1,
	},
	{ label: "Tab", key: "closeTab", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Estado", key: "closeState", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{
		label: "Etiquetas",
		key: "tags.name[]?",
		format: "arrayTruncate",
		headerPosition: "left",
		canSort: false,
		dataPosition: "left",
		width: 1,
	},
];

export const abiertasColumns = [
	{
		label: "Plataforma",
		key: "channel.platform.name",
		format: "string",
		headerPosition: "center",
		dataPosition: "center",
		width: 1,
		canSort: false,
	},
	{ label: "Tab", key: "state", format: "string", headerPosition: "center", dataPosition: "center", width: 1, canSort: false },
	{ label: "Estado", key: "searchableAlert", format: "string", headerPosition: "center", dataPosition: "center", width: 1, canSort: false },
	{ label: "Nombre", key: "contact.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1, canSort: false },
	{ label: "Teléfono", key: "contact.phone", format: "phone", headerPosition: "center", dataPosition: "center", width: 1, canSort: false },
	{ label: "Atiende", key: "user.fullName", format: "string", headerPosition: "center", dataPosition: "left", width: 1, canSort: false },
	{ label: "Grupo", key: "group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1, canSort: false },
	{
		label: "Etiquetas",
		key: "tags.name[]?",
		format: "arrayTruncate",
		headerPosition: "left",
		dataPosition: "left",
		width: 1,
		canSort: false,
	},
	{ label: "Tiempo", key: "time", format: "string", headerPosition: "left", dataPosition: "left", width: 16, canSort: false },
];

export const etiquetasColumns = [
	{ label: "Etiquetas", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 2 },
	{
		label: "Cantidad",
		key: "count",
		format: "blankZero",
		headerPosition: "center",
		dataPosition: "center",
		width: 1,
		sum: true,
		orderKey: "count",
	},
	{ label: "%", key: "percent", format: "string", headerPosition: "left", dataPosition: "left", width: 15, sum: true },
];

export const etiquetasGrupoColumns = [
	{ label: "Grupos", key: "chat.group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Etiquetas", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 2 },
	{ label: "Cantidad", key: "count", format: "number", headerPosition: "center", dataPosition: "center", width: 1, sum: true },
	{ label: "%", key: "percent", format: "string", headerPosition: "left", dataPosition: "left", width: 15, sum: true },
];

export const anioMesColumns = [
	{ label: "Año", key: "year", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Mes", key: "month", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Conversaciones", key: "chats", format: "blankZero", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Nuevos Contactos", key: "contacts", format: "blankZero", headerPosition: "left", dataPosition: "left", width: 15 },
];

export const noTrabajadasColumns = [
	{ label: "Tab", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Estado", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Contacto", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Telefono", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Usuario Cierre", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Fecha Cierre", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
	{ label: "Etiquetas", key: "closingAgent", format: "string", headerPosition: "left", dataPosition: "center", width: 1 },
];

export const actionsColumns = [
	{ label: "ID", key: "chatId", format: "string", width: 0.5 },
	{ label: "Fecha/Hora", key: "createdDate", format: "dateTime", width: 1 },
	{ label: "Acción", key: "action", format: "string", width: 0.5 },
	{ label: "Usuario", key: "userAction.fullName", format: "string", width: 1 },
	{ label: "Contacto", key: "chat.contact.name", format: "string", width: 1 },
	{ label: "Teléfono", key: "chat.contact.phone", format: "phone", width: 1 },
	{ label: "Plataforma", key: "chat.channel.platform.name", format: "string", width: 1 },
	{ label: "Tel/Cuenta", key: "chat.channel.label", format: "string", width: 1 },
	{ label: "Palabras", key: "extra", format: "truncate", width: 16, headerPosition: "left" },
];

export const chatTagsColumns = [
	{ label: "Etiqueta", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 2 },
	{ label: "Notas", key: "notas", format: "string", headerPosition: "center", dataPosition: "left", width: 2, canSort: false },
	{
		label: "Cantidad",
		key: "count",
		format: "blankZero",
		headerPosition: "center",
		dataPosition: "center",
		width: 1,
		sum: true,
		orderKey: "count",
	},
	{ label: "%", key: "percent", format: "string", headerPosition: "left", dataPosition: "left", width: 1, sum: true },
];

export const chatTagsDetailedColumns = [
	{ label: "Contacto", key: "chat.contact.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Teléfono", key: "chat.contact.phone", format: "phone", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Etiqueta", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{
		label: "Nota",
		key: "nota",
		format: "string",
		headerPosition: "center",
		dataPosition: "left",
		width: 2,
		canSort: false,
		render: ({ nota }) => {
			React.createElement(NotaCell, { nota });
		},
	},
	{ label: "Usuario", key: "chat.user.fullName", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Grupo", key: "chat.group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Plataforma", key: "chat.channel.platform.name", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Cuenta", key: "chat.channel.label", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Fecha Entrada", key: "chat.createdDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Fecha Cierre", key: "chat.closeDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
];

export const columnsByRoute = {
	chats: cerradasDetalladasColumns,
	"/reports/historic/detailed": cerradasDetalladasColumns,
	"/reports/combined/detailed": cerradasDetalladasColumns,
	"/reports/general/summary": abiertasColumns,
	"/reports/general/tags": etiquetasColumns,
	"/reports/general/group-tags": etiquetasGrupoColumns,
	"/reports/general/year-month": anioMesColumns,
	"/reports/historic/actions": actionsColumns,
	"/reports/chattags": chatTagsColumns,
	"/reports/chattags/detailed": chatTagsDetailedColumns,
};
